export default "__VITE_ASSET__w19Tap$I__"